import React from 'react';
import { SvgLowFloorIcon } from './LowFloorIcon';

const WIDTH = 22; //全体の幅
const HEIGHT = 26; //全体の高さ
const TRIANGLE_HEIGHT = 6; //三角部分の高さ

export type DirectionType = 'top' | 'right' | 'bottom' | 'left';

type TransformsType = {
  [key in DirectionType]: {
    transform: string;
    x: number;
    y: number;
  };
};

// 方向ごとの回転と位置調整
const transforms: TransformsType = {
  top: {
    transform: ``,
    x: 0,
    y: 2
  },
  right: {
    transform: `translate(${HEIGHT}, ${0}) rotate(90)`,
    x: 0,
    y: -2
  },
  bottom: {
    transform: `translate(${WIDTH}, ${HEIGHT}) rotate(180)`,
    x: 0,
    y: -2.5
  },
  left: {
    transform: `translate(${0}, ${WIDTH}) rotate(270)`,
    x: 4.5,
    y: -2
  }
};
Object.freeze(transforms);

type Props = {
  x: number;
  y: number;
  direction: DirectionType;
  no: number;
  color: string;
  logo: boolean;
  onClick?: () => void;
};

const TrainZoomMap: React.FC<Props> = (props) => {
  const { x, y, direction, no, color, logo, onClick } = props;

  return (
    <g transform={`translate(${x},${y})`} onClick={onClick} cursor='pointer'>
      <g transform={transforms[direction].transform}>
        <path
          fill={color}
          stroke='white'
          strokeWidth={0.75}
          d={`M${WIDTH / 2} 0 L0 ${TRIANGLE_HEIGHT} v${
            HEIGHT - TRIANGLE_HEIGHT
          } h${WIDTH} v${-(HEIGHT - TRIANGLE_HEIGHT)} Z`}
        ></path>
      </g>

      <g
        transform={`translate(${transforms[direction].x} ${transforms[direction].y})`}
      >
        <text
          x={WIDTH / 2}
          y={logo ? TRIANGLE_HEIGHT + 1.2 : HEIGHT / 2 - 1}
          fontSize={5}
          fontWeight='bold'
          fontFamily='sans-serif'
          textAnchor='middle'
          dominantBaseline='central'
        >
          {no}
        </text>
        {logo && (
          <g transform={`translate(5.2, 10.5) scale(0.075)`}>
            <SvgLowFloorIcon></SvgLowFloorIcon>
          </g>
        )}
      </g>
    </g>
  );
};

export default React.memo(TrainZoomMap);
